/* Narthex: Zweitprodukt-Upsell im Warenkorb ("Ergänze deinen Einkauf").

   Legt das angebotene Produkt per Ajax in den Warenkorb UND setzt den Rabattcode.
   Der Rabatt wird also nur gewährt, wenn der Kunde das Angebot wirklich nutzt,
   nie still im Hintergrund.

   Zweiter Weg: Produkte mit vielen Varianten (Alphabite) verlinken auf die
   Produktseite. Beim Klick merken wir uns den Code in der sessionStorage und
   setzen ihn, sobald dort etwas in den Warenkorb gelegt wurde. */
(function () {
  if (window.narthexCartUpsellReady) return;
  window.narthexCartUpsellReady = true;

  var SOURCE = 'narthex-cart-upsell';
  var FLAG = 'narthexZweitprodukt';
  var FLAG_MAX_AGE = 1000 * 60 * 120;
  var busy = false;

  function route(name, fallback) {
    try {
      if (typeof Theme !== 'undefined' && Theme.routes && Theme.routes[name]) return Theme.routes[name];
    } catch (error) {
      /* Theme noch nicht da */
    }
    return fallback;
  }

  function postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Fehler');
        return data;
      });
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      return response.json();
    });
  }

  function rememberPendingCode(code) {
    try {
      sessionStorage.setItem(FLAG, JSON.stringify({ code: code, ts: Date.now() }));
    } catch (error) {
      /* privater Modus, dann eben ohne */
    }
  }

  function readPendingCode() {
    try {
      var raw = sessionStorage.getItem(FLAG);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.code) return null;
      if (Date.now() - parsed.ts > FLAG_MAX_AGE) {
        sessionStorage.removeItem(FLAG);
        return null;
      }
      return parsed.code;
    } catch (error) {
      return null;
    }
  }

  function clearPendingCode() {
    try {
      sessionStorage.removeItem(FLAG);
    } catch (error) {
      /* egal */
    }
  }

  /* Rabattcode zusätzlich zu bereits gesetzten Codes anwenden, gleicher Weg wie
     das Rabattfeld des Themes (siehe cart-discount.js). */
  function applyDiscountCode(code) {
    if (!code) return Promise.resolve(null);

    return getCart().then(function (cart) {
      var existing = (cart.discount_codes || [])
        .map(function (entry) {
          return entry && entry.code;
        })
        .filter(Boolean);

      if (existing.indexOf(code) !== -1) return null;

      return postJson(route('cart_update_url', '/cart/update.js'), {
        discount: existing.concat([code]).join(','),
      });
    });
  }

  function notifyCartUpdated(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: SOURCE,
          data: { source: SOURCE, itemCount: cart ? cart.item_count : undefined },
        },
      })
    );
  }

  function showError(element) {
    var container = element.closest('[data-narthex-upsell]');
    var errorEl = container ? container.querySelector('[data-narthex-upsell-error]') : null;
    if (!errorEl) return;
    errorEl.textContent = 'Konnte nicht hinzugefügt werden. Bitte versuch es nochmals.';
    errorEl.classList.remove('hidden');
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    /* Variante muss auf der Produktseite gewählt werden: Code vormerken */
    var selectLink = event.target.closest('[data-narthex-upsell-select]');
    if (selectLink) {
      var linkContainer = selectLink.closest('[data-narthex-upsell]');
      if (linkContainer) rememberPendingCode(linkContainer.getAttribute('data-narthex-upsell-code'));
      return;
    }

    var button = event.target.closest('[data-narthex-upsell-add]');
    if (!button) return;

    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    var variantId = button.getAttribute('data-narthex-upsell-add');
    if (!variantId) return;

    var container = button.closest('[data-narthex-upsell]');
    var code = container ? container.getAttribute('data-narthex-upsell-code') : null;
    var originalHtml = button.innerHTML;

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.innerHTML = '<span class="narthex-upsell__spinner"></span>';
    busy = true;

    postJson(route('cart_add_url', '/cart/add.js'), {
      items: [{ id: Number(variantId), quantity: 1, properties: { _zweitprodukt: 'warenkorb-upsell' } }],
    })
      .then(function () {
        return applyDiscountCode(code);
      })
      .then(function () {
        clearPendingCode();
        return getCart();
      })
      .then(function (cart) {
        notifyCartUpdated(cart);
      })
      .catch(function (error) {
        button.innerHTML = originalHtml;
        button.removeAttribute('aria-busy');
        button.disabled = false;
        showError(button);
        console.error('[narthex-cart-upsell]', error);
      })
      .finally(function () {
        busy = false;
      });
  });

  /* Kunde kam über "Auswählen" von der Produktseite zurück: Code nachziehen,
     sobald dort etwas in den Warenkorb gelegt wurde. */
  document.addEventListener('cart:update', function (event) {
    if (busy) return;
    if (event && event.detail && event.detail.data && event.detail.data.source === SOURCE) return;

    var code = readPendingCode();
    if (!code) return;

    busy = true;
    getCart()
      .then(function (cart) {
        if (!cart || cart.item_count < 2) {
          busy = false;
          return null;
        }
        clearPendingCode();
        return applyDiscountCode(code).then(getCart).then(notifyCartUpdated);
      })
      .catch(function (error) {
        console.error('[narthex-cart-upsell]', error);
      })
      .finally(function () {
        busy = false;
      });
  });
})();
